import { FeatureFlags } from '@logz-pkg/enums';
import { sessionStateService } from '@logz-pkg/frontend-services';
import { useObservable } from '@logz-pkg/observable';
import { useCallback, useMemo } from 'react';

export const useFeatureFlagCallback = () => {
  const session = useObservable(sessionStateService.session);
  const featureFlags = session?.featureFlags;

  const isFFEnabled = useCallback(
    (featureName: keyof typeof FeatureFlags): boolean => featureFlags?.includes(FeatureFlags[featureName]) ?? false,
    [featureFlags],
  );

  return { isFFEnabled };
};

export const useFeatureFlagState = (featureName: keyof typeof FeatureFlags) => {
  const { isFFEnabled } = useFeatureFlagCallback();

  const isFeatureEnabled = useMemo(() => isFFEnabled(featureName), [isFFEnabled, featureName]);

  return { isFeatureEnabled };
};
